import { useEffect, useMemo, useState } from "react";
import { Button, DatePicker, Space, Tooltip } from "antd";
import createAxiosInstanceNew from "../../../Api/AxiosInstance/AxiosInstance";
import { RedoOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import UsePermissions from "../../../hooks/usePermissions";
import { UseAdmin } from "../../../hooks";

const { RangePicker } = DatePicker;

const flagsGenerateInitialStates = {
  isInactive: true,
  message: " Consulta por fechas para generar",
};

const WeekSelect = (props) => {
  const { setShopsData, refetchTrigger } = props;

  const { hasAllPermissionsChild1, hasPermission, hasAllBrandsViewChild1, hasAllShopsViewChild1 } =
    UsePermissions();

  const { brandfiMarcaId, branchFiSucursalId } = UseAdmin();

  const hasMissingDownloadPermission = useMemo(() => {
    return hasPermission("CHILD1", "missing.download");
  }, [hasPermission]);

  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [loading, setLoading] = useState(false);

  const [flagsConsult, setFlagsConsult] = useState({
    isInactive: false,
    message: "Elige rango de fecha.",
  });
  const [flagsGenerate, setFlagsGenerate] = useState(flagsGenerateInitialStates);

  const onChange = (dateString) => {
    setDate({
      startDate: dateString[0],
      endDate: dateString[1],
    });
  };

  useEffect(() => {
    onChange(["", ""]);
    setFlagsGenerate(flagsGenerateInitialStates);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchTrigger]);

  const handleOnClick = async (date, isRefresh = false) => {
    if (isRefresh) {
      onChange(["", ""]);
      setFlagsGenerate(flagsGenerateInitialStates);
    }
    try {
      setLoading(true);
      const axiosInstance = await createAxiosInstanceNew();
      const res = await axiosInstance.get(`faltante`, {
        params: {
          FIPAISID: 1,
          ...(!hasAllBrandsViewChild1 &&
            !hasAllPermissionsChild1 && {
              FIMARCAID: brandfiMarcaId,
            }),
          ...(!hasAllShopsViewChild1 &&
            !hasAllPermissionsChild1 &&
            !hasAllBrandsViewChild1 && {
              FISUCURSALID: branchFiSucursalId,
            }),
          ...(!isRefresh && {
            FDFECHAINICIO: date.startDate,
            FDFECHAFIN: date.endDate,
          }),
        },
      });
      if (res.status === 200) {
        if (!isRefresh) {
          setFlagsConsult({
            isInactive: true,
            message: "Elige otro rango de fecha o recarga.",
          });
        }

        if (res.data.body.length > 0 && !isRefresh) {
          setFlagsGenerate({
            isInactive: false,
            message: "",
          });
        }
        if (res.data.body.length === 0) {
          setFlagsGenerate({
            isInactive: true,
            message: "No hay datos para generar.",
          });
        }

        setShopsData(res.data.body);
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (date.startDate && date.endDate) {
      setFlagsConsult({
        isInactive: false,
        message: "",
      });
    } else {
      setFlagsConsult({
        isInactive: true,
        message: "Elige rango de fecha.",
      });
    }
  }, [date]);

  const handleOnDownload = async () => {
    try {
      setLoading(true);
      const axiosInstance = await createAxiosInstanceNew();
      const res = await axiosInstance.get(`faltante/reporte`, {
        params: {
          FIPAISID: 1,
          ...(!hasAllBrandsViewChild1 &&
            !hasAllPermissionsChild1 && {
              FIMARCAID: brandfiMarcaId,
            }),
          ...(!hasAllShopsViewChild1 &&
            !hasAllPermissionsChild1 &&
            !hasAllBrandsViewChild1 && {
              FISUCURSALID: branchFiSucursalId,
            }),
          ...(date.startDate &&
            date.endDate && {
              FDFECHAINICIO: date.startDate,
              FDFECHAFIN: date.endDate,
            }),
        },
      });

      if (res.status === 200 && res.data.success) {
        const fileUrl = res.data.body;

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "reporte.csv");
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
      } else {
        console.error("Error: No se pudo generar el reporte.");
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };
  const disabledDate = (current) => {
    const today = dayjs().endOf("day");
    // Calcular la fecha mínima restando 52 semanas
    let minDate = dayjs().subtract(52, "week").startOf("day");
    // Si minDate no es lunes
    if (minDate.day() !== 1) {
      minDate = minDate.subtract((minDate.day() + 6) % 7, "day"); // Mover al lunes anterior
    }
    return current && (current > today || current < minDate);
  };
  return (
    <>
      <Space direction="horizontal" className="responsive-buttons">
        <Tooltip title="Recargar">
          <Button
            type="default"
            onClick={() => {
              handleOnClick(date, true);
            }}
            loading={loading}
          >
            {loading ? null : (
              <RedoOutlined
                style={{
                  fontSize: "20px",
                }}
              />
            )}
          </Button>
        </Tooltip>
        <RangePicker
          value={
            date.startDate && date.endDate ? [dayjs(date.startDate), dayjs(date.endDate)] : null
          }
          placeholder={["Fecha inicial", "Fecha final"]}
          onChange={(dates, dateString) => {
            onChange(dateString);
          }}
          allowClear={false}
          disabledDate={disabledDate}
        />
        <Tooltip title={flagsConsult.message}>
          <Button
            className={"button-styles-add-element"}
            type="primary"
            onClick={() => {
              handleOnClick(date, false);
            }}
            disabled={flagsConsult.isInactive || loading}
            loading={loading}
          >
            Consultar
          </Button>
        </Tooltip>
        {(hasMissingDownloadPermission || hasAllPermissionsChild1) && (
          <Tooltip title={flagsGenerate.message}>
            <Button
              className={"button-styles-download-element"}
              type="primary"
              onClick={handleOnDownload}
              disabled={flagsGenerate.isInactive || loading}
              loading={loading}
            >
              Generar CSV
            </Button>
          </Tooltip>
        )}
      </Space>
    </>
  );
};
export default WeekSelect;
